import { useEffect, useRef } from 'react'
import { useToast } from '../context/ToastContext'
import * as productService from '../services/productService'

const SESSION_KEY = 'shopora-low-stock-alert-shown'

export function useLowStockAlert(enabled: boolean, threshold: number, storeId?: number | null) {
  const { pushToast } = useToast()
  const shownRef = useRef(false)

  useEffect(() => {
    if (!enabled || storeId == null || shownRef.current) return
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem(SESSION_KEY) === String(storeId)) {
      shownRef.current = true
      return
    }

    let cancelled = false
    productService
      .fetchProducts({ page: 1, limit: 1, lowStock: true })
      .then((res) => {
        if (cancelled || res.total <= 0) return
        shownRef.current = true
        if (typeof sessionStorage !== 'undefined') {
          sessionStorage.setItem(SESSION_KEY, String(storeId))
        }
        pushToast({
          variant: 'info',
          message: `${res.total} product${res.total === 1 ? '' : 's'} at or below ${threshold} units — review stock in Products.`,
          duration: 7000,
        })
      })
      .catch(() => {})

    return () => {
      cancelled = true
    }
  }, [enabled, pushToast, storeId, threshold])
}
